import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import * as SecureLS from 'secure-ls';
@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {
  constructor(private routes: Router) {}
  private ls = new SecureLS({ encodingType: 'aes' });
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (this.ls.get('token') != null) {
        if(parseInt(this.ls.get('role')) == 2 || parseInt(this.ls.get('role')) == 3 ) {
          return true;
        } else {
          this.ls.remove('token');
          
          Swal.fire(
            'Expired!',
            'Unauthorized to access this page',
            'error'
          );
          this.routes.navigate(['/']);
          return false;
        }
        
      } else {
        Swal.fire(
          'Expired!',
          'Unauthorized to access this page',
          'error'
        );
        this.routes.navigate(['/']);
        return false;
      }
    
    return true;
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
